module.exports = __webpack_public_path__ + "assets/AirbnbCereal-Book.86b15ac031e0507ad790afafd9adf7f7.ttf";